import React, { useMemo } from 'react'
import PropTypes from 'prop-types/prop-types'
import classNames from 'classnames'
import { useHideToggle } from '../hooks/useHideToggle'

const Container = (props) => {
  const {
    name,
    styleNames,
    childIndex,
    hide = false,
    flow,
    children
  } = props

  PropTypes.checkPropTypes(Container.propTypes, props, 'prop', 'Container')

  const hideInternal = useHideToggle(name, hide)

  const attributes = useMemo(() => {
    return {
      ...name && { id: name },
      className: classNames(
        'g-container',
        `child-${childIndex}`,
        flow,
        { [styleNames]: !!styleNames },
        { hidden: hideInternal }
      )
    }
  }, [hideInternal])

  return (
    <div {...attributes}>{children}</div>
  )
}

Container.propTypes = {
  name: PropTypes.string,
  styleNames: PropTypes.string,
  childIndex: PropTypes.number,
  hide: PropTypes.bool,
  className: PropTypes.string,
  flow: PropTypes.string,
  children: PropTypes.node
}

export default Container
